import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import OfficialPage from '../OfficialPage';

import './WinningRecord.less';

export default class WinningRecord extends OfficialPage {
  state = {
    currentTabIndex: 1,
    myPrizeList: [],
    storeStyle: {}
  }

  constructor(props) {
    super(props);
    document.title = '中奖记录';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      franchisee: options.franchisee || ''
    })
  }

  componentDidMount(options) {
    var that = this
    that.getMyPrizeCenter(1)
    this.getAppECStoreConfig()
  }

  clickTap = e => {
    var that = this
    var index = e.currentTarget.dataset.index,
      data = {}
    data.currentTabIndex = index
    that.setData(data)
    that.getMyPrizeCenter(index)
  }
  getMyPrizeCenter = category => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/myPrizeCenter',
      method: 'post',
      data: {
        category: category,
        page: 1,
        page_size: 999,
        sub_app_id: that.data.franchisee
      },
      success: function (res) {
        that.setData({
          myPrizeList: res.data
        })
      }
    })
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    }, this.data.franchisee)
  }

  render() {
    const {
      showGetUserInfo,
      currentTabIndex,
      storeStyle,
      myPrizeList
    } = this.state
    return (
      <div className="official-page winning-record">
        <TopNav title="中奖记录"/>
        <div className="winningRecord page" id="winningRecord">
          <div className="record-tab-list">
            <div
              data-index="1"
              style={convertLineStyleData(
                currentTabIndex == 1
                  ? 'color:' +
                  storeStyle.theme +
                  ';border-color:' +
                  storeStyle.theme
                  : ''
              )}
              className={currentTabIndex == 1 ? 'active' : ''}
              onClick={this.clickTap}
            >
              大转盘
            </div>
            <div
              data-index="2"
              style={convertLineStyleData(
                currentTabIndex == 2
                  ? 'color:' +
                  storeStyle.theme +
                  ';border-color:' +
                  storeStyle.theme
                  : ''
              )}
              className={currentTabIndex == 2 ? 'active' : ''}
              onClick={this.clickTap}
            >
              砸金蛋
            </div>
            <div
              data-index="3"
              style={convertLineStyleData(
                currentTabIndex == 3
                  ? 'color:' +
                  storeStyle.theme +
                  ';border-color:' +
                  storeStyle.theme
                  : ''
              )}
              className={currentTabIndex == 3 ? 'active' : ''}
              onClick={this.clickTap}
            >
              刮刮乐
            </div>
          </div>
          <div className="record-content-body">
            <div className="scrollContainer">
              <ScrollView scroll-y="true">
                {myPrizeList.map((item, index) => {
                  return (
                    <div
                      className="record-wrap-list"
                      key={item.id}
                      data-id={item.id}
                      hidden={myPrizeList == ''}
                    >
                      <div className="record-name">
                        {item.prize_level + ':' + item.custom_prize_title}
                      </div>
                      {item.custom_prize_title != item.prize_title && (
                        <div className="record-name custom-record-name">
                          <span>奖品</span>
                          {item.prize_title}
                        </div>
                      )}
                      <div className="record-start">
                        <div className="record-apply">
                          {'使用日期：' +
                            item.start_use_date +
                            '至' +
                            item.end_use_date}
                        </div>
                        {/*  <view wx:if="{{item.coupon_type != 1}}" class="record-staus" style={convertLineStyleData('color:#ff7100;')}>{{item.is_selected=='0'?'未使用':'已使用'}}</view>  */}
                      </div>
                      {item.coupon_type != 1 && (
                        <div
                          className={
                            'record-staus ico-moon icon-winning-record-' +
                            (item.is_selected == '0' ? 'nouse' : 'used')
                          }
                          style={convertLineStyleData(
                            'color:' +
                            (item.is_selected == '0' ? '#FF7100' : '#999999')
                          )}
                        ></div>
                      )}
                      <div className="record-end">
                        {'中奖时间：' + item.add_time}
                      </div>
                    </div>
                  )
                })}
              </ScrollView>
              <div className="record-none" hidden={myPrizeList != ''}>
                暂无任何中奖记录
              </div>
            </div>
            {/*  <view class="scrollContainer" hidden="{{currentTabIndex!=1}}"></view>  */}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/winning-record/WinningRecord.jsx